import { createEpicMiddleware } from 'redux-observable';
import rootReducer from './rootReducer';
import rootEpic from './rootEpic';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

const epicMiddleware = createEpicMiddleware();

const defaultMiddlewareOpts = {
  serializableCheck: {
    // Actions should generally not contain functions (however we have made some exceptions)
    ignoredActionPaths: [
      // Functional config can be passed around in actions
      'payload.config',
      // Functional query params can be passed around in actions
      'payload.query',
    ],
    ignoredPaths: [
      // Worksheets can have functional config
      'worksheetEditor.config',
      // Worksheets for grid dry mass entry also have functional config, but we can't drill down to that specific path.
      'worksheetGrid.worksheets',
      // Worksheets grids can have functional query parameters
      'worksheetGrid.query',
      // Equipment can have functional config
      'equipment.config',
    ],
  },
  immutableCheck: {
    ignoredPaths: [
      // The amount of data and nested structure of grid worksheets pushes this beyond acceptable performance
      'worksheetGrid.worksheets',
    ],
  },
};

const store = configureStore({
  reducer: rootReducer,
  middleware: [...getDefaultMiddleware(defaultMiddlewareOpts), epicMiddleware],
});

epicMiddleware.run(rootEpic);

type RootState = ReturnType<typeof rootReducer>;

// Extends the RootState type which makes autocomplete show our actual state
declare module 'react-redux' {
  interface DefaultRootState extends RootState {}
}

export type { RootState };
export default store;
